import Constants from "./constants";
import Utils from "./utils";
const dayjs = require("dayjs");
const isoWeek = require('dayjs/plugin/isoWeek');
dayjs.extend(isoWeek);

const DateUtils = {
    formatDateToBucketDate(date) {
        if (date) {
          return dayjs(date).format(Constants.BUCKET_FORMAT);
        }
        return dayjs().format(Constants.BUCKET_FORMAT);
    },
    getBeforeNthDayFromToday(selectedDate,nthDay) {
      return dayjs(selectedDate).startOf("day").subtract(nthDay, "day")
                  .format(Constants.BUCKET_FORMAT); 
    },
    getDayDifference(dateValue) {
      const date1 = dayjs(dateValue);
      const date2 = dayjs();
      const dateDiff = date2.diff(date1,'day',true);
      const days = Math.floor(dateDiff);
      return days;
    },
    formatDateToProvidedDate(date, format) {
        if(date) {
            return dayjs(date).format(format);
        }

        return '-';
    },
    getDayFromDayJsnumber(dayOfWeek) {
      if(dayOfWeek == 0)
         return 'Sun'; 
      if(dayOfWeek == 1)
         return 'Mon';
      if(dayOfWeek == 2)
         return 'Tue';      
      if(dayOfWeek == 3)
         return 'Wed';    
      if(dayOfWeek == 4)
         return 'Thu';  
      if(dayOfWeek == 5)
         return 'Fri';   
      if(dayOfWeek == 6)
         return 'Sat';    
      else 
         return '';       
    },
    formatPeriod(dt) {
      if (dayjs(dt).format(Constants.PERIOD_TS_FORMAT) ==dayjs().format(Constants.PERIOD_TS_FORMAT)){
         return "TODAY";
      }
      
      return dayjs(dt).format(Constants.PERIOD_TS_FORMAT);
    },
    formatUnixTimeStamp(unixTS) {
      let timeVal = dayjs(Utils.formatTimestamp(unixTS)).format(Constants.MDY_TS_FORMAT);
      let formattedTime = dayjs(timeVal).format(Constants.TIME_12_HRS_FORMAT);

      //console.log('formatUnixTimeStamp unixTS: '+unixTS+' time: '+formattedTime);
      return formattedTime;
    },
    formatTimestampToTime(dateTime) {
      return dayjs(dateTime).format(Constants.TIME_12_HRS_FORMAT);
    },
    formatTimestampTo24HrsTime(dateTime) {
      return dayjs(dateTime).format(Constants.TIME_24_HRS_FORMAT);
    },
    formatUnixTimeStampAddMinutes(unixTS, minutes) {
      let dateTime = dayjs(Utils.formatTimestamp(unixTS));
      dateTime = dateTime.add(minutes,'minute')
      let timeVal = dateTime.format(Constants.MDY_TS_FORMAT);
      let formattedTime = dayjs(timeVal).format(Constants.TIME_12_HRS_FORMAT);

      //console.log('formatUnixTimeStamp unixTS: '+unixTS+' time: '+formattedTime);
      return formattedTime;
    },
    formatDate(date, format) {
        if(date) {
            return dayjs(date).format(format);
        }

        return '-';
    },
    getWeekRange(selectedDate) {
        const date = dayjs(selectedDate);
        const weekStart = date.isoWeekday(1); // Set to Monday of the current week
        const weekEnd = weekStart.add(6, 'days');

        const startDay = weekStart.format('DD');
        const endDay = weekEnd.format('DD');
        const startMonth = weekStart.format('MMM');
        const endMonth = weekEnd.format('MMM');
        const startYear = weekStart.format('YYYY');
        const endYear = weekEnd.format('YYYY');

        if (startMonth === endMonth) {
            return `${startDay}-${endDay} ${startMonth} ${startYear}`;
        } else {
            return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
        }
    }
}

export default DateUtils;